import { getEnvironmentalVariables } from './env-service';
import { loadEnterpriseConnection } from './local-storage-service';

const env = getEnvironmentalVariables();

function getForgeBaseUrl() {
  switch (env.MAD_API_ENV) {
    case 'development':
      return 'https://app-dev.ingrid.com';
    case 'stage':
      return 'https://app-stg.ingrid.com';
    case 'production':
      return 'https://app.ingrid.com';
  }
}

export type ForgePath = `/${string}`;

export function getForgeUrl(siteId: string, path: ForgePath) {
  return `${getForgeBaseUrl()}/sites/${siteId}${path}`;
}

function hasLoggedInViaApoteket() {
  return !!env.MAD_APOTEKET_ADFS && loadEnterpriseConnection() === env.MAD_APOTEKET_ADFS;
}

export function getForgeOptInUrl(siteId: string, path: ForgePath = '/checkout/routes') {
  // `path` may carry its own query string, so let URL merge the params instead of
  // concatenating a second `?`
  const url = new URL(getForgeUrl(siteId, path));
  url.searchParams.set('new_experience', '1');

  if (hasLoggedInViaApoteket()) {
    url.searchParams.set('sso', 'apoteket');
  }

  return url.toString();
}
